import { Heading, Text } from 'ui-kit/typography'
import { PropsWithChildren } from 'react'
import { ContentDataType } from './contentData'
import clsx from 'clsx'
import classes from './UniversalIntegrationsContent.module.scss'

export const UniversalIntegrationsContent = ({
  item,
  children,
}: PropsWithChildren<{
  item: ContentDataType
}>) => {
  const { number, title, subtitle1, subtitle2, hasLinks } = item

  return (
    <div className={classes.content}>
      <div className={classes.box}>
        <div className={classes.glow} />
        <Text as={'span'} size={'sm'} className={classes.number}>
          {number}
        </Text>
      </div>
      <div className={clsx(classes.description)}>
        <Heading as={'h2'} size={'xl'} center className={classes.title}>
          {title}
        </Heading>
        {subtitle1 && (
          <Text size={'lg'} center balance className={classes.subtitle}>
            {subtitle1}
          </Text>
        )}
        {subtitle2 && (
          <Text size={'lg'} center balance className={classes.subtitle}>
            {subtitle2}
          </Text>
        )}
        {hasLinks && (
          <Text size={'lg'} center balance className={classes.subtitle}>
            {children}
          </Text>
        )}
      </div>
    </div>
  )
}
